import { useEffect } from "react"
import { useGetConfig } from "../api/config/get.ts"
import { initSleek } from "../utils/sleek.ts"

export function useSleekPlan() {
    const { data } = useGetConfig()

    useEffect(() => {
        if (!data?.SLEEK_PRODUCT_ID) return
        initSleek(data.SLEEK_PRODUCT_ID)
    }, [data?.SLEEK_PRODUCT_ID])
}
